/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { View } from "react-native";
import { useDispatch, useSelector } from "react-redux";

import { upduoLighterGray } from "config/UpduoColors";
import { SearchBar } from "UpduoLibrary";
import { RootState } from "store/types";
import { ActionCreators } from "actions";

export default function TranscriptSearch({}) {
  const dispatch = useDispatch();
  const selfObject = useSelector((state: RootState) => state.selfObject);

  const [searchText, setSearchText] = useState("");

  if (!selfObject.organizationShowTranscription) return null;

  const handleSearch = () => {
    if (searchText.length >= 3) {
      dispatch(ActionCreators.setTranscriptionKeyword(searchText));
    } else if (!searchText) {
      dispatch(ActionCreators.setTranscriptionKeyword(null));
    }
  };

  return (
    <View
      style={{
        width: 260,
        marginRight: 17,
        justifyContent: "center",
      }}
    >
      <SearchBar
        placeholder={"Search sessions, keywords"}
        placeholderTextColor={upduoLighterGray}
        onChangeText={setSearchText}
        onKeyPress={(e) => e["key"] === "Enter" && handleSearch()}
        onClick={handleSearch}
      />
    </View>
  );
}
